import { Container } from '@swordhealth/ui-corporate';
import Section from '@/components/ui/Section';
import { SPACE_DESKTOP, SPACE_TABLET, SPACE_MOBILE } from '@/components/ui/Section';
import styled, { css } from 'styled-components';
import { PrettySectionClipPath } from '@/components/ui/Section/PrettySection';
import { motion } from 'framer-motion';

export const WrappedContainer = styled(Container)`
  overflow: hidden;
  position: relative;
  padding-top: 192px;
  padding-bottom: 192px;

  @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
    padding-top: 106px;
    padding-bottom: 106px;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    padding-top: 32px;
    padding-bottom: 92px;
  }
`;

export const WrappedSection = styled(Section)`
  overflow: hidden;
  padding-bottom: 0;

  ${PrettySectionClipPath};

  ${({ spaceBottom }) =>
    !!spaceBottom &&
    css`
      padding-bottom: ${SPACE_DESKTOP};

      @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
        padding-bottom: ${SPACE_TABLET};
      }

      @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
        padding-bottom: ${SPACE_MOBILE};
      }
    `};

  @media (max-width: ${({ theme }) => theme.breakpoints.max_md}px) {
    clip-path: none;
  }
`;

export const Wrapper = styled.div`
  padding-top: 0;
  position: relative;

  @media (max-width: ${({ theme }) => theme.breakpoints.max_md}px) {
    padding-top: 0;
  }
`;

export const Overlay = styled.div`
  background: ${({ $angle = 90 }) => `
    linear-gradient(
      ${$angle}deg,
      rgb(from white r g b / 0%) 1%,
      rgb(from #eba68e r g b / 22%) 40%,
      rgb(from #efe330 r g b / 36%) 100%
    )
  `};
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  mix-blend-mode: multiply;
  pointer-events: none;
  position: absolute;
  z-index: 1;
`;

export const MotionVideoContainer = styled(motion.video)`
  height: 100%;
  width: 100%;
  max-width: 50%;
  object-fit: contain;
  overflow: visible;
  pointer-events: none;
  position: relative;

  @media (max-width: ${({ theme }) => theme.breakpoints.max_md}px) {
    aspect-ratio: 9/16;
    justify-self: center;
    max-height: 432px;
    max-width: 100%;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.max_sm}px) {
    aspect-ratio: 9/16;
    max-height: 300px;
  }
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: row;
  gap: 64px;
  justify-content: space-between;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.max_md}px) {
    align-items: center;
    flex-direction: column;
    gap: 40px;
  }
`;
